module.exports = __webpack_public_path__ + "static/img/px_login_left.f89ca43b.png";